export default __webpack_public_path__ + "static/media/spotting-OFF.bea74d26.png";